import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/product_subitem',
    name: 'POST_PRODUCT_SUBITEM',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
